import Axios from 'axios'
import _ from 'lodash'


class UserInfo {
    constructor() {
        //public variable here
    }


    getInfoApi(app) {
        var that = this;
        return Axios.get(`/api/user/g`).then(function({ data }) {
            if (data && data.S && data.D) {
                app.setUser(data.D);
            } else {
                window.location.href = "/auth/logout";
            }
        });
    }
}
export default UserInfo



// WEBPACK FOOTER //
// ./src/modules/UserInfo.js